import { FormattedInputContainer } from "./style";
import NumberFormat from "react-number-format";

export const FormattedInput = ({
  value,
  placeholder,
  name,
  inputAttr,
  formatHandleChange,
  disabled,
}) => {
  return (
    <FormattedInputContainer>
      {/* <input
                type={"text"}
                name={name}
                placeholder={placeholder}
                onChange={handleChange}
                id={name}
                value={value}
                disabled={disabled}
                {...inputAttr}
                className="hidden-input"
            /> */}
      <NumberFormat
        name={name}
        placeholder={placeholder}
        onValueChange={(e) => {
          formatHandleChange(e.floatValue);
        }}
        id={name}
        disabled={disabled}
        {...inputAttr}
        className="hidden-input"
        thousandsGroupStyle="thousand"
        value={value}
        prefix="₦"
        decimalSeparator="."
        displayType="input"
        type="text"
        thousandSeparator={true}
        allowNegative={true}
      />
    </FormattedInputContainer>
  );
};
